// extracted by mini-css-extract-plugin
export default {"help":"Help_help__AMN7I","image":"Help_image__W2pG4"};